/* tslint:disable */
/* eslint-disable */
/**
 * GroupManage API
 * グループ情報を操作する
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * グループから集計取引を削除する情報
 * @export
 * @interface DeleteAggregateBusinessFromGroupInfo
 */
export interface DeleteAggregateBusinessFromGroupInfo {
    /**
     * グループID
     * @type {string}
     * @memberof DeleteAggregateBusinessFromGroupInfo
     */
    'groupId': string;
    /**
     * 集計取引ID
     * @type {Array<string>}
     * @memberof DeleteAggregateBusinessFromGroupInfo
     */
    'aggregateBusinessIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteAggregateBusinessFromGroupRequest
 */
export interface DeleteAggregateBusinessFromGroupRequest {
    /**
     * 
     * @type {DeleteAggregateBusinessFromGroupInfo}
     * @memberof DeleteAggregateBusinessFromGroupRequest
     */
    'deleteAggregateBusinessFromGroupInfo'?: DeleteAggregateBusinessFromGroupInfo;
}
/**
 * グループから集計取引を削除するレスポンス
 * @export
 * @interface DeleteAggregateBusinessFromGroupResponse
 */
export interface DeleteAggregateBusinessFromGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteAggregateBusinessFromGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAggregateBusinessFromGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteAggregateBusinessFromGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteAggregateBusinessFromGroupResponse
     */
    'result': object;
}
/**
 * グループを削除する情報
 * @export
 * @interface DeleteGroupInfo
 */
export interface DeleteGroupInfo {
    /**
     * グループID
     * @type {string}
     * @memberof DeleteGroupInfo
     */
    'groupId': string;
}
/**
 * 
 * @export
 * @interface DeleteGroupRequest
 */
export interface DeleteGroupRequest {
    /**
     * 
     * @type {DeleteGroupInfo}
     * @memberof DeleteGroupRequest
     */
    'deleteGroupInfo'?: DeleteGroupInfo;
}
/**
 * グループ情報削除レスポンスで返す情報
 * @export
 * @interface DeleteGroupResponse
 */
export interface DeleteGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteGroupResponse
     */
    'result': object;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * グループ情報取得レスポンスで返す情報
 * @export
 * @interface GetGroupResponse
 */
export interface GetGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {GetGroupResponseResult}
     * @memberof GetGroupResponse
     */
    'result': GetGroupResponseResult;
}
/**
 * グループ情報取得レスポンスで返す情報
 * @export
 * @interface GetGroupResponseResult
 */
export interface GetGroupResponseResult {
    /**
     * 
     * @type {Array<GetGroupResponseResultData>}
     * @memberof GetGroupResponseResult
     */
    'data': Array<GetGroupResponseResultData>;
}
/**
 * グループ取得の個々の情報
 * @export
 * @interface GetGroupResponseResultData
 */
export interface GetGroupResponseResultData {
    /**
     * グループID
     * @type {string}
     * @memberof GetGroupResponseResultData
     */
    'groupId': string;
    /**
     * グループ名
     * @type {string}
     * @memberof GetGroupResponseResultData
     */
    'groupName': string;
}
/**
 * グループに集計取引を追加する情報
 * @export
 * @interface PostAggregateBusinessToGroupInfo
 */
export interface PostAggregateBusinessToGroupInfo {
    /**
     * グループID
     * @type {string}
     * @memberof PostAggregateBusinessToGroupInfo
     */
    'groupId': string;
    /**
     * 集計取引ID
     * @type {Array<string>}
     * @memberof PostAggregateBusinessToGroupInfo
     */
    'aggregateBusinessIds': Array<string>;
}
/**
 * 
 * @export
 * @interface PostAggregateBusinessToGroupRequest
 */
export interface PostAggregateBusinessToGroupRequest {
    /**
     * 
     * @type {PostAggregateBusinessToGroupInfo}
     * @memberof PostAggregateBusinessToGroupRequest
     */
    'postAggregateBusinessToGroupInfo'?: PostAggregateBusinessToGroupInfo;
}
/**
 * グループに集計取引を追加するレスポンス
 * @export
 * @interface PostAggregateBusinessToGroupResponse
 */
export interface PostAggregateBusinessToGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessToGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessToGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessToGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {PostAggregateBusinessToGroupResponseResult}
     * @memberof PostAggregateBusinessToGroupResponse
     */
    'result': PostAggregateBusinessToGroupResponseResult;
}
/**
 * グループに集計取引を追加するレスポンスの個々の情報
 * @export
 * @interface PostAggregateBusinessToGroupResponseResult
 */
export interface PostAggregateBusinessToGroupResponseResult {
    /**
     * グループID
     * @type {string}
     * @memberof PostAggregateBusinessToGroupResponseResult
     */
    'groupId'?: string;
}
/**
 * グループを作成する情報
 * @export
 * @interface PostGroupInfo
 */
export interface PostGroupInfo {
    /**
     * グループ名
     * @type {string}
     * @memberof PostGroupInfo
     */
    'groupName': string;
}
/**
 * 
 * @export
 * @interface PostGroupRequest
 */
export interface PostGroupRequest {
    /**
     * 
     * @type {PostGroupInfo}
     * @memberof PostGroupRequest
     */
    'postGroupInfo'?: PostGroupInfo;
}
/**
 * グループ情報登録レスポンスで返す情報
 * @export
 * @interface PostGroupResponse
 */
export interface PostGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof PostGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {PostGroupResponseResult}
     * @memberof PostGroupResponse
     */
    'result': PostGroupResponseResult;
}
/**
 * グループ情報登録レスポンスで返す情報
 * @export
 * @interface PostGroupResponseResult
 */
export interface PostGroupResponseResult {
    /**
     * グループID
     * @type {string}
     * @memberof PostGroupResponseResult
     */
    'groupId'?: string;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * グループ名を更新する情報
 * @export
 * @interface UpdateGroupNameInfo
 */
export interface UpdateGroupNameInfo {
    /**
     * グループ名
     * @type {string}
     * @memberof UpdateGroupNameInfo
     */
    'groupName': string;
}
/**
 * 
 * @export
 * @interface UpdateGroupNameRequest
 */
export interface UpdateGroupNameRequest {
    /**
     * 
     * @type {UpdateGroupNameInfo}
     * @memberof UpdateGroupNameRequest
     */
    'updateGroupNameInfo'?: UpdateGroupNameInfo;
}
/**
 * グループ名変更レスポンスで返す情報
 * @export
 * @interface UpdateGroupNameResponse
 */
export interface UpdateGroupNameResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateGroupNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateGroupNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupNameResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof UpdateGroupNameResponse
     */
    'result': object;
}

/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計取引をグループから削除する
         * @param {DeleteAggregateBusinessFromGroupRequest} deleteAggregateBusinessFromGroupRequest グループから削除する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAggregateBusinessFromGroup: async (deleteAggregateBusinessFromGroupRequest: DeleteAggregateBusinessFromGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAggregateBusinessFromGroupRequest' is not null or undefined
            assertParamExists('deleteAggregateBusinessFromGroup', 'deleteAggregateBusinessFromGroupRequest', deleteAggregateBusinessFromGroupRequest)
            const localVarPath = `/group/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAggregateBusinessFromGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループの削除
         * @param {DeleteGroupRequest} deleteGroupRequest 削除するグループを指定する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (deleteGroupRequest: DeleteGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteGroupRequest' is not null or undefined
            assertParamExists('deleteGroup', 'deleteGroupRequest', deleteGroupRequest)
            const localVarPath = `/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループの一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計取引をグループに登録する
         * @param {PostAggregateBusinessToGroupRequest} postAggregateBusinessToGroupRequest グループに登録する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAggregateBusinessToGroup: async (postAggregateBusinessToGroupRequest: PostAggregateBusinessToGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postAggregateBusinessToGroupRequest' is not null or undefined
            assertParamExists('postAggregateBusinessToGroup', 'postAggregateBusinessToGroupRequest', postAggregateBusinessToGroupRequest)
            const localVarPath = `/group/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAggregateBusinessToGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループの新規作成
         * @param {PostGroupRequest} postGroupRequest 作成するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGroup: async (postGroupRequest: PostGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postGroupRequest' is not null or undefined
            assertParamExists('postGroup', 'postGroupRequest', postGroupRequest)
            const localVarPath = `/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループ名の更新
         * @param {string} groupId グループID
         * @param {UpdateGroupNameRequest} updateGroupNameRequest 更新するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupName: async (groupId: string, updateGroupNameRequest: UpdateGroupNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateGroupName', 'groupId', groupId)
            // verify required parameter 'updateGroupNameRequest' is not null or undefined
            assertParamExists('updateGroupName', 'updateGroupNameRequest', updateGroupNameRequest)
            const localVarPath = `/group/name/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計取引をグループから削除する
         * @param {DeleteAggregateBusinessFromGroupRequest} deleteAggregateBusinessFromGroupRequest グループから削除する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest: DeleteAggregateBusinessFromGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAggregateBusinessFromGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.deleteAggregateBusinessFromGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループの削除
         * @param {DeleteGroupRequest} deleteGroupRequest 削除するグループを指定する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(deleteGroupRequest: DeleteGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(deleteGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.deleteGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループの一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.getGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計取引をグループに登録する
         * @param {PostAggregateBusinessToGroupRequest} postAggregateBusinessToGroupRequest グループに登録する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest: PostAggregateBusinessToGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAggregateBusinessToGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.postAggregateBusinessToGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループの新規作成
         * @param {PostGroupRequest} postGroupRequest 作成するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGroup(postGroupRequest: PostGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGroup(postGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.postGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループ名の更新
         * @param {string} groupId グループID
         * @param {UpdateGroupNameRequest} updateGroupNameRequest 更新するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupName(groupId: string, updateGroupNameRequest: UpdateGroupNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateGroupNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupName(groupId, updateGroupNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GroupApi.updateGroupName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計取引をグループから削除する
         * @param {DeleteAggregateBusinessFromGroupRequest} deleteAggregateBusinessFromGroupRequest グループから削除する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest: DeleteAggregateBusinessFromGroupRequest, options?: any): AxiosPromise<DeleteAggregateBusinessFromGroupResponse> {
            return localVarFp.deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループの削除
         * @param {DeleteGroupRequest} deleteGroupRequest 削除するグループを指定する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(deleteGroupRequest: DeleteGroupRequest, options?: any): AxiosPromise<DeleteGroupResponse> {
            return localVarFp.deleteGroup(deleteGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループの一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(options?: any): AxiosPromise<GetGroupResponse> {
            return localVarFp.getGroup(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計取引をグループに登録する
         * @param {PostAggregateBusinessToGroupRequest} postAggregateBusinessToGroupRequest グループに登録する集計取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest: PostAggregateBusinessToGroupRequest, options?: any): AxiosPromise<PostAggregateBusinessToGroupResponse> {
            return localVarFp.postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループの新規作成
         * @param {PostGroupRequest} postGroupRequest 作成するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGroup(postGroupRequest: PostGroupRequest, options?: any): AxiosPromise<PostGroupResponse> {
            return localVarFp.postGroup(postGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループ名の更新
         * @param {string} groupId グループID
         * @param {UpdateGroupNameRequest} updateGroupNameRequest 更新するグループテーブル情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupName(groupId: string, updateGroupNameRequest: UpdateGroupNameRequest, options?: any): AxiosPromise<UpdateGroupNameResponse> {
            return localVarFp.updateGroupName(groupId, updateGroupNameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     * 
     * @summary 集計取引をグループから削除する
     * @param {DeleteAggregateBusinessFromGroupRequest} deleteAggregateBusinessFromGroupRequest グループから削除する集計取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest: DeleteAggregateBusinessFromGroupRequest, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).deleteAggregateBusinessFromGroup(deleteAggregateBusinessFromGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループの削除
     * @param {DeleteGroupRequest} deleteGroupRequest 削除するグループを指定する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public deleteGroup(deleteGroupRequest: DeleteGroupRequest, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).deleteGroup(deleteGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループの一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public getGroup(options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).getGroup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計取引をグループに登録する
     * @param {PostAggregateBusinessToGroupRequest} postAggregateBusinessToGroupRequest グループに登録する集計取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest: PostAggregateBusinessToGroupRequest, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).postAggregateBusinessToGroup(postAggregateBusinessToGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループの新規作成
     * @param {PostGroupRequest} postGroupRequest 作成するグループテーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public postGroup(postGroupRequest: PostGroupRequest, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).postGroup(postGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループ名の更新
     * @param {string} groupId グループID
     * @param {UpdateGroupNameRequest} updateGroupNameRequest 更新するグループテーブル情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public updateGroupName(groupId: string, updateGroupNameRequest: UpdateGroupNameRequest, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).updateGroupName(groupId, updateGroupNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



